import { MuiThemeProvider } from '@material-ui/core/styles';
import CustomIconButton from 'components/CustomIconButton/CustomIconButton';
import CloseIcon from 'components/Icons/CloseIcon';
import { SnackbarKey, SnackbarProvider, useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import styles from './App.scss';
import { Layout } from './components/Layout';
import { getCustomMaterialTheme } from './config/MaterialTheme';
import { EnvironmentType, loadEnvironments } from './library/Apis';
import PageRoutes from './pages/PageRoutes';
import { getStore } from './store';
import { AlertProvider } from 'contexts/alert/AlertContext';
import RouteChangeTrackerNotifications from 'components/RouteNotification';
import LoaderGlobal from 'components/Loader/LoaderApp/LoaderGlobal';

const rootClassName = styles.rootClassName;

const SnackbarActionButton = ({ snack }: { snack: SnackbarKey }) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <CustomIconButton
      theme='transluscent'
      onClick={() => closeSnackbar(snack)}
      icon={<CloseIcon />}
    />
  );
};

export default function App() {
  const [env, setEnv] = useState<EnvironmentType>();

  useEffect(() => {
    loadEnvironments((loadedEnvironment) => {
      setEnv(loadedEnvironment);
    });
  }, []);

  if (!env) {
    return (
      <div className={rootClassName}>
        <LoaderGlobal />
      </div>
    );
  }

  return (
    <MuiThemeProvider theme={getCustomMaterialTheme()}>
      <Provider store={getStore(env)}>
        <BrowserRouter>
          <RouteChangeTrackerNotifications />
          <SnackbarProvider
            action={(k) => <SnackbarActionButton snack={k} />}
            preventDuplicate
            autoHideDuration={4000}
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <AlertProvider>
              <Layout>
                <PageRoutes />
              </Layout>
            </AlertProvider>
          </SnackbarProvider>
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  );
}
